/**
 * Landing Page Component
 *
 * Main landing page for Examfy - Public marketing content.
 * No authentication required.
 */

import { Seo } from '@/shared/components';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
// import { TestimonialsSection } from './components/TestimonialsSection';
// import { FAQSection } from './components/FAQSection';
import { SecuritySection } from './components/SecuritySection';
import { ContactSection } from './components/ContactSection';
import { useSmoothScroll } from './hooks';

export function LandingPage() {
  // Enable smooth scrolling for anchor links
  useSmoothScroll();

  return (
    <>
      <Seo
        title="Examfy | Plataforma Médica para Gestão de Dados e Pacientes"
        description="Plataforma completa para médicos e pacientes: organize exames, automatize a extração de dados com IA e a transcrição de consultas médicas."
      />
      <HeroSection />
      <FeaturesSection />
      <PricingSection />
      <ContactSection />
      {/* <TestimonialsSection /> */}
      {/* <FAQSection /> */}
      <SecuritySection />
    </>
  );
}

// Default export for lazy loading
export default LandingPage;
